import React from "react";
import SEO from "@/components/SEO";
import { COMPANY } from "@/data/site";
import { Link } from "react-router-dom";

const SmsTermsPage = () => (
  <>
    <SEO
      title="SMS Terms & Conditions | Crosstown Movers"
      description="SMS program terms for Crosstown Movers customer notifications — opt-in, opt-out, message frequency, and support."
      path="/sms-terms"
    />
    <section className="py-20 md:py-28 bg-[var(--ct-primary)] text-white">
      <div className="section-container">
        <div className="label-xs text-white mb-3">Legal</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
          SMS Terms &amp; Conditions
        </h1>
        <p className="mt-4 text-white/80 max-w-3xl">
          Last updated: January 2026
        </p>
      </div>
    </section>

    <section className="py-16 bg-white">
      <article className="section-container max-w-3xl prose prose-neutral">
        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-0" style={{ fontFamily: "Outfit" }}>Program Description</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          Crosstown Movers operates an SMS text-messaging program to confirm quote
          requests, provide scheduling updates, and follow up with customers who
          request a free moving quote in Casper, Mills, and the surrounding Wyoming area.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Opt-In</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          By submitting your phone number through the Instant Quote wizard or the quote
          form on crosstownmoversllc.com, you consent to receive SMS messages from
          Crosstown Movers related to your quote request and move. Consent is not a
          condition of purchase.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Message Frequency</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          Message frequency varies. You can typically expect between 1 and 5 messages
          per quote request, covering confirmation, follow-up, scheduling, and moving-day
          coordination.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Message &amp; Data Rates</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          Message &amp; data rates may apply based on your carrier and plan. Crosstown
          Movers does not charge for SMS; any charges come from your mobile carrier.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Opt-Out</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          You can opt out at any time by replying <strong>STOP</strong> to any message.
          You will receive a one-time confirmation that you have been unsubscribed.
          After opting out, you will no longer receive SMS messages from us.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Help</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          For help, reply <strong>HELP</strong> to any message or call us at{" "}
          <a href={`tel:${COMPANY.phoneTel}`} className="font-semibold text-[var(--ct-primary)] underline">
            {COMPANY.phone}
          </a>.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Supported Carriers</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          AT&amp;T, T-Mobile, Verizon Wireless, Sprint, Boost, Virgin Mobile, Cricket,
          MetroPCS, U.S. Cellular, and most major US wireless carriers. Carriers are
          not liable for delayed or undelivered messages.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Privacy</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          We will never share, sell, or rent your mobile number to third parties for
          marketing purposes. Phone numbers submitted through our site are used solely
          to respond to your quote request and coordinate your move.
        </p>

        <h2 className="text-2xl font-semibold text-[var(--ct-primary)] mt-8" style={{ fontFamily: "Outfit" }}>Contact</h2>
        <p className="text-[var(--ct-text-muted)] leading-relaxed">
          Crosstown Movers<br />
          {COMPANY.address}<br />
          Phone: <a href={`tel:${COMPANY.phoneTel}`} className="font-semibold text-[var(--ct-primary)] underline">{COMPANY.phone}</a><br />
          Email: <a href={`mailto:${COMPANY.email}`} className="text-[var(--ct-primary)] underline">{COMPANY.email}</a>
        </p>

        <div className="mt-12 p-6 rounded-2xl bg-[var(--ct-accent)]">
          <p className="text-sm text-[var(--ct-primary)] m-0">
            Return to <Link to="/" className="font-semibold underline">homepage</Link> or
            read our <Link to="/faq" className="font-semibold underline">FAQ</Link>.
          </p>
        </div>
      </article>
    </section>
  </>
);

export default SmsTermsPage;
